// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-webmap-panel-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--divider-color);
  padding: 2px;
}
.ngw-webmap-panel-header > span {
  padding-left: 6px;
  font-weight: var(--ngw-head-font-weight);
  font-size: 15px;
  font-family: var(--ngw-head-font-family-list);
}
.ngw-webmap-panel-header > .spacer {
  flex-grow: 1;
}
.ngw-webmap-panel-header button {
  color: var(--icon-color);
}
.alert-desc {
  background: var(--divider-color);
  border: 1px solid var(--divider-color);
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/panel/header/PanelHeader.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,YAAA;AACJ;AALA;EAOQ,iBAAA;EACA,wCAAA;EACA,eAAA;EACA,6CAAA;AACR;AAXA;EAcQ,YAAA;AAAR;AAdA;EAkBQ,wBAAA;AADR;AAKA;EACI,gCAAA;EACA,sCAAA;AAHJ","sourcesContent":[".ngw-webmap-panel-header {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--divider-color);\n    padding: 2px;\n\n    >span {\n        padding-left: 6px;\n        font-weight: var(--ngw-head-font-weight);\n        font-size: 15px;\n        font-family: var(--ngw-head-font-family-list);\n    }\n\n    >.spacer {\n        flex-grow: 1;\n    }\n\n    button {\n        color: var(--icon-color);\n    }\n}\n\n.alert-desc {\n    background: var(--divider-color);\n    border: 1px solid var(--divider-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
